import styled, { css } from 'styled-components';

import { setSvgColor } from 'styles/mixins';

export const Container = styled.div`
  height: 48px;
  min-width: 272px;
  width: fit-content;

  cursor: pointer;
  user-select: none;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => css`
    ${setSvgColor(theme.colors.white.main)};

    gap: ${theme.padding.smallest};
    padding: 0 ${theme.padding.input};
    border-radius: ${theme.borderRadius.big};
    background-color: ${theme.colors.grey.main};

    &:hover {
      background-color: ${theme.colors.grey.hover};
    }
  `}
`;
